export function validateTagOrKeyword(value: string): boolean {
  if (!value || value.length === 0) return false;
  const expr = /^[äöüßA-Z0-9 /-]{2,100}$/i;
  return expr.test(value);
}